/**
 * Dependencies
 */
import http from '../../../services/HttpService'

/**
 * Get activity
 */
const getActivity = ({ commit }) => {
    commit('GET_ACTIVITY')
    http.get('activity/')
        .then(res => commit('GET_ACTIVITY_SUCCESS', res.data))
        .catch(() => commit('GET_ACTIVITY_FAILURE'))
}

/**
 * Toggle the activity state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const toggleActivity = ({ commit, dispatch, state }) => {
    commit('TOGGLE_ACTIVITY')
    if (state.showIndicator) {
        dispatch('disableActivityIndicator')
    }
}

/**
 * Disable the alert indicator
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const disableActivityIndicator = ({ commit }) => commit('DISABLE_INDICATOR')

/**
 * Disable the activity feed
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const closeActivity = ({ commit }) => commit('CLOSE_ACTIVITY')

/**
 * Mark a single item as read
 *
 * @return {Void}
 */
const markActivityAsRead = ({ commit }, id) => {
    http.patch(`activity/${id}`)
        .then(() => commit('MARK_ITEM_READ', id))
        .catch(err => console.log(err))
}

/**
 * Mark all items as read
 *
 * @return {Void}
 */
const markAllActivityAsRead = ({ commit }) => {
    http.patch(`activity/`)
        .then(() => commit('MARK_ALL_READ'))
        .catch(err => console.log(err))
}

/**
 * Handle new activity
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const prependNewActivity = ({ commit }, activity) => commit('PREPEND_ACTIVITY', activity)

/**
 * Send popup notification
 *
 * @param  {Function} options.commit
 * @param  {Object} activity
 * @return {Void}
 */
const sendPopupNotification = ({ commit }, activity) => {
    commit('SEND_ACTIVITY_POPUP', activity)
}

const resetActivityPopup = ({ commit }) => commit('RESET_ACTIVITY_POPUP')

export default {
    getActivity,
    closeActivity,
    toggleActivity,
    prependNewActivity,
    resetActivityPopup,
    markActivityAsRead,
    sendPopupNotification,
    markAllActivityAsRead,
    disableActivityIndicator
}



// WEBPACK FOOTER //
// ./src/state/modules/activity/actions.js